import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FilterOption } from './types';

export const useFilterData = (url: string) => {
  const [data, setData] = useState<FilterOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(url);
      const filtered = response.data
        .filter((item: any) => item.isActive)
        .map((item: any) => ({
          id: item.id,
          name: item.displayName ?? item.name,
        }));
      setData(filtered);
    } catch (err: any) {
      setError(err.message);
      console.error('Error fetching filter data:', err);
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
